import React, { useEffect } from "react";
import { ConfigProvider, theme as antTheme } from "antd";
import LoginPage from "./Pages/Login";
import Home from "./Pages/PostLogin";
import { BrowserRouter, Route, Routes, useNavigate } from "react-router-dom";
import { getCookie } from "./utilities/utll";
import { useThemeStore } from "./store/useThemeStore";

function AppRoutes() {
  const navigate = useNavigate();
  useEffect(() => {
    const isLoggedIn = getCookie("auth");
    if (isLoggedIn) navigate("/postlogin");
    else navigate("/login");
  }, [navigate]);

  return (
    <Routes>
      <Route path="/"          element={<LoginPage />} />
      <Route path="/login"     element={<LoginPage />} />
      <Route path="/postlogin" element={<Home />} />
    </Routes>
  );
}

export default function App() {
  const { themeColor, isDark } = useThemeStore();

  return (
    <ConfigProvider
      theme={{
        algorithm: isDark ? antTheme.darkAlgorithm : antTheme.defaultAlgorithm,
        token: {
          colorPrimary: themeColor,
          colorLink:    themeColor,
        },
      }}
    >
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </ConfigProvider>
  );
}
